import { render } from "./VTea.vue?vue&type=template&id=5d2c3f1e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VTea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d2c3f1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d2c3f1e', __exports__)) {
    api.reload('5d2c3f1e', __exports__)
  }
  
  module.hot.accept("./VTea.vue?vue&type=template&id=5d2c3f1e", () => {
    api.rerender('5d2c3f1e', render)
  })

}


export default __exports__